<template>
  <v-dialog max-width="600px" v-model="showDialogAddNewService" @update:model-value="handleDialogClose"
            @keydown.esc="handleEscape">
    <v-card>
      <v-card-title>
        <h4>Add Service</h4>
      </v-card-title>
<!--      newClientLevel0-->
      <v-card-text v-if="true">
        <v-text-field   v-model="newServiceName" label="... service name" :rules="inputRulesName"></v-text-field>
        <v-text-field   v-model="newServicePublicName" label="... service public name" :rules="inputRulesName"></v-text-field>
        <v-text-field   v-model="newServiceDescription" label="... service description" :rules="inputRulesName"></v-text-field>
        <v-card-subtitle class="font-weight-bold"></v-card-subtitle>
        <v-row>
          <v-col>
            <v-divider class="mt-2"></v-divider>
            <v-autocomplete name="Select Client"
                      v-model="newServiceManagedByClientID"
                      :items="subclientsList"
                      item-value="client_id"
                      item-title="name"
                      label="Select Owner "
                      outlined
                      dense
                      clearable
            >
            </v-autocomplete>

            <v-select  name="Select MVNO"
                       v-model="newServiceMvnoID"
                       :items="mvnos"
                       item-value="id"
                       item-title="name"
                       label="Select MVNO"
                       outlined
                       dense
                       clearable
            >
            </v-select>

            <v-row class="justify-space-between " gutter="10px">
              <v-col cols="12" sm="6" class="pa-2">
                <v-select  name="Select Service Type"
                           v-model="newServiceTypeID"
                           :items="serviceTypesFormatted"
                           item-value="id"
                           item-title="displayName"
                           label="Select Service Type"
                           outlined
                           dense
                           clearable
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" class="pa-2">
                <v-select  name="Select Client Type"
                           v-model="newServiceAppliedToClientTypeID"
                           :items="clientTypes"
                           item-value="id"
                           item-title="name"
                           label="Select applied to client Type"
                           outlined
                           dense
                           clearable
                >
                </v-select>
              </v-col>
            </v-row>

            <!-- Self Applied, Allow Multiple, Needs Delivery, and Available to Subclients toggles -->
            <v-row class="align-center mb-3 mt-3">
              <v-col cols="6" sm="3">
                <v-switch
                  v-model="selfApplied"
                  label="Self Applied"
                  :color="selfApplied ? 'success' : 'error'"
                  hide-details
                  density="compact"
                ></v-switch>
              </v-col>
              <v-col cols="6" sm="3">
                <v-switch
                  v-model="allowMultiple"
                  label="Allow Multiple"
                  :color="allowMultiple ? 'success' : 'error'"
                  hide-details
                  density="compact"
                ></v-switch>
              </v-col>
              <v-col cols="6" sm="3">
                <v-switch
                  v-model="needsDelivery"
                  label="Needs Delivery"
                  :color="needsDelivery ? 'success' : 'error'"
                  hide-details
                  density="compact"
                ></v-switch>
              </v-col>
              <v-col cols="6" sm="3">
                <v-switch
                  v-model="availableToSubclients"
                  label="Available to Subclients"
                  :color="availableToSubclients ? 'success' : 'error'"
                  hide-details
                  density="compact"
                ></v-switch>
              </v-col>
              <v-col cols="6" sm="3">
                <v-switch
                  v-model="showInSearch"
                  label="Show in Search"
                  :color="showInSearch ? 'primary' : 'error'"
                  hide-details
                  density="compact"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row class="mb-3">
              <v-col cols="6">
                <v-text-field
                  v-model="labelOnSearchButton"
                  label="Label on Search Button"
                  hint="Leave empty to use service name"
                  persistent-hint
                  density="compact"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Payment Method Types -->
            <v-row class="mb-3">
              <v-col cols="12">
                <div class="text-subtitle-2 mb-2">Allowed Payment Methods</div>
                <v-chip-group
                  v-model="selectedPaymentMethodTypeIds"
                  multiple
                  column
                  selected-class="text-primary"
                >
                  <v-chip
                    v-for="pmt in paymentMethodTypes"
                    :key="pmt.id"
                    :value="pmt.id"
                    filter
                    variant="outlined"
                  >
                    {{ pmt.name }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pr-2">
                <v-select  name="Select Billing Type" class=""
                           v-model="newServiceBillingTypeID"
                           :items="serviceBillingTypes"
                           item-value="id"
                           item-title="name"
                           label="Select Billing Type"
                           outlined
                           dense
                           clearable
                >
                </v-select>
              </v-col>
              <v-col>
                <v-select  v-if="newServiceBillingTypeID===2" name="Select Billing Period"
                           v-model="newServiceBillingPeriodID"
                           :items="serviceBillingPeriods"
                           item-value="id"
                           item-title="name"
                           label="Select Billing Period"
                           outlined
                           dense
                           clearable
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pr-2">
                <v-text-field   v-model="newServicePrice" label="... service price" :rules="inputRulesPrice"></v-text-field>
              </v-col>
              <v-col class="pr-2">
                <v-text-field   v-model="newServiceValidity" label="... service validity" :rules="inputRulesValidity"></v-text-field>
              </v-col>
              <v-col>
                <v-select  name="Select Currency"
                           v-model="newServiceCurrencyID"
                           :items="currencies"
                           item-value="id"
                           item-title="name"
                           label="Select Currency"
                           outlined
                           dense
                           clearable
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>


        <v-row justify="space-around" class="mt-3 mb-3">
          <v-btn  @click="closeAddNewClient()" large color="danger">Cancel</v-btn>
          <v-btn large color="primary" @click="addNewServiceLocal" class="success " :loading="loading">Add Service</v-btn>
        </v-row>
      </v-card-text>

      <!--      newClientLevel0-->



    </v-card>
  </v-dialog>
</template>

<script>
import format from 'date-fns/format'
// import db from '@/fb'

import {log} from "@/composables/useLog";
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {getServicesGeneralSettings} from "@/composables/useGetGeneralSettings";
import {getClientTree} from  "@/composables/useGetClientsAPI"
import {addNewService} from "@/composables/useAddNewService";
export default {
  props:["showAddNewService", "clientsHierarchy"],
  data() {
    return {
      newServiceName:"new service test",
      newServiceDescription:"new service test description",
      newServicePublicName:"new service test public",
      newServiceManagedByClientID:null,
      newServiceTypeID:13,
      currencies:[],
      newServiceCurrencyID:1,
      newServiceMvnoID:null,
      mvnos:[],
      newServiceValidity:null,
      newServicePrice:null,
      newServiceAppliedToClientTypeID:2,
      availableToSubclients:false,
      newServiceBillingTypeID:1,
      newServiceBillingPeriodID:1,
      selfApplied: false,
      allowMultiple: false,
      needsDelivery: false,
      showInSearch: false,
      labelOnSearchButton: '',
      selectedPaymentMethodTypeIds: [],
      showDialogAddNewService:true,
      showParams:false,
      menu: false,
      subclientsList:[],
      clientTypes:[],
      serviceTypes:[],
      serviceBillingTypes:[],
      serviceBillingPeriods:[],
      paymentMethodTypes: [],

      inputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      inputRulesValidity: [
        v => !!v || 'This field is required',
      ],
      inputRulesPrice: [
        (value) => !!value || "This field is required.",
        (value) =>
            /^\d{1,6}(\.\d{1,2})?$/.test(value) ||
            "Must be a number with up to 6 digits and 2 decimals.",
      ],
      inputRulesName: [
        v => !!v || 'This field is required',
        v => v.length >= 5 || 'Minimum length is 5 characters'
      ],
      loading: false,
    }
  },
  methods: {
    handleDialogClose(value) {
      // Emitted when dialog visibility changes
      log("am primit eveniment ca v-dialog s.a inchis")
      if (!value) {
        // alert("am primit eveniment ca v-dialog s.a inchis si no value")
        this.$emit('dialogClosedEvent');
      }
    },
    handleEscape() {
      // alert("am primit eveniment ca v-dialog a apasat escape")
      // Emitted specifically when Escape is pressed
      this.$emit('dialogEscapedEvent');
    },
    addNewServiceLocal() {
      // alert("calling addNewService")

        const form = {
          newServiceName: this.newServiceName,
          newServiceDescription: this.newServiceDescription,
          newServicePublicName: this.newServicePublicName,
          newServiceTypeID: this.newServiceTypeID,
          newServiceManagedByClientID: this.newServiceManagedByClientID,
          newServiceAppliedToClientTypeID: this.newServiceAppliedToClientTypeID,
          newServiceBillingTypeID: this.newServiceBillingTypeID,
          newServiceBillingPeriodID: this.newServiceBillingPeriodID,
          newServiceCurrencyID: this.newServiceCurrencyID,
          newServiceMvnoID: this.newServiceMvnoID,
          newServicePrice: this.newServicePrice,
          newServiceValidity: this.newServiceValidity,
          newServiceAvailableToSubclients: this.availableToSubclients,
          newServiceSelfApplied: this.selfApplied,
          newServiceAllowMultiple: this.allowMultiple,
          newServiceNeedsDelivery: this.needsDelivery,
          newServiceShowInSearch: this.showInSearch,
          newServiceLabelOnSearchButton: this.labelOnSearchButton,
          newServicePaymentMethodTypeIds: this.selectedPaymentMethodTypeIds
        }
        log(form)
      // alert(typeof this.newServiceName)
      // alert(this.newServiceName)
       if(this.newServiceName=="" || this.newServiceName==null){
         alert("name canot be ''")
       }
       else if(this.newServiceDescription==null){
         alert("newServiceDescription canot be null")
       }
      else if(this.newServiceValidity==null){
         alert("newServiceValidity canot be null")
       }
      else if(this.newServiceTypeID==null){
        alert("newServiceTypeID canot be null")
      }
      else if(this.newServiceAppliedToClientTypeID==""){
        alert("newServiceAppliedToClientTypeID canot be null")
      }
       else if(this.newServiceBillingTypeID==""){
         alert("newServiceBillingTypeID canot be null")
       }
      else if(this.newServicePrice=="" || this.newServicePrice==null){
        alert("newServicePrice cannot be null")
      }
      else{
        log("intram pe adauga serviciul")
        this.loading = true
        addNewService(this.token,form).then((response)=>{
          if(response.error==true){
            alert(response.message)
          }else{
            alert(response.message)
            this.$emit("newServiceAddedEvent");
            this.showDialogAddNewService=false
          }
          this.loading=false
        })
      }
    },
    flattenClientTree(clients, level = 0) {
      let result = [];
      for (const client of clients) {
        const prefix = level > 0 ? '—'.repeat(level) + ' ' : '';
        result.push({
          client_id: client.client_id,
          name: prefix + client.name
        });
        if (client.children && client.children.length > 0) {
          result = result.concat(this.flattenClientTree(client.children, level + 1));
        }
      }
      return result;
    },
    async fetchClientTree() {
      // Use hierarchy from parent prop if available (already loaded by ServicesList)
      if (this.clientsHierarchy && this.clientsHierarchy.length > 0) {
        log("Using clientsHierarchy prop instead of API call")
        this.subclientsList = this.clientsHierarchy.map(c => ({
          client_id: c.id,
          name: (c.level > 0 ? '—'.repeat(c.level) + ' ' : '') + c.name
        }));
        log("subclientsList from prop: " + this.subclientsList.length + " items")
        return;
      }
      try {
        const response = await getClientTree(this.token,this.clientID);
        if (response.error) {
          this.errorMessage = response.error_title || "Error";
          this.errorDialog = true;
        } else {
          log("ne.am intors din fetchClientTree si am primit response")
          log(response)
          const rootClient = response.clients_list[0];
          let flatList = [{
            client_id: rootClient.client_id,
            name: rootClient.name
          }];
          const children = rootClient.children || [];
          flatList = flatList.concat(this.flattenClientTree(children, 1));
          log("flatList hierarchical:")
          log(flatList)
          this.subclientsList = flatList;
        }
      } catch (err) {
        console.error("Error fetching client tree:", err);
        this.errorMessage = "Unexpected error occurred.";
        this.errorDialog = true;
      }
    },

    closeAddNewClient(){
      this.showDialogAddNewService=false;
      this.$emit("closeAddNewClientEvent")
    }
  },

  created() {
    const { getLoggedIn, user, loggedIn, token } = useGetLoggedIn();
    getLoggedIn().then(() => {

// Logs from the provided instructions
      log("dupa created in Dashboard avem:");
      log("autorizare in Dashboard after getLoggedIn");
      log("user:");
      log(user);
      log("loggedIn: " + loggedIn.value);
      log("token: " + token.value);
      this.clientID=user.value.client_id
      // this.token = this.$store.getters.getToken; // Setting token from store
      this.token = token.value
      getServicesGeneralSettings().then((response) => {
        log("---------------------------")
        log("typeof response.service_types")
        log(typeof response.service_types)
        log(response.service_types)
        log("---------------------------")
        log("typeof response.billing_types")
        log(typeof response.billing_types)
        log(response.billing_types)
        log("---------------------------")
         log("typeof response.billing_periods")
        log(typeof response.billing_periods)
        log(response.billing_periods)
        log("---------------------------")
        // alert(1)
        this.clientTypes=response.client_types
        this.serviceTypes = response.service_types
        this.currencies = response.currencies
        this.serviceBillingTypes = response.billing_types
        this.serviceBillingPeriods = response.billing_periods
        this.paymentMethodTypes = response.payment_method_types || []
        this.mvnos = response.mvnos || []
        this.fetchClientTree().then(()=>{
          this.showDialogAddNewService=true
        })
        this.showDialogAddNewService= this.showAddNewService
      })
    });

  },
  computed: {
    // showAddNewClientComputed(){
    //    return this.showAddNewService = false
    // },
    formattedDate () {
      console.log(this.due)
      return this.due ? format(this.due, 'Do MMM YYYY') : ''
    },
    serviceTypesFormatted() {
      return this.serviceTypes.map(st => ({
        id: st.id,
        name: st.name,
        description: st.description,
        displayName: st.description ? `${st.name} (${st.description})` : st.name
      }))
    }
  }
}
</script>
